import axios from "axios";
import {Credencials} from "../interfaes/user";
export async function onHandelLogin(obj:Credencials) {

    return await axios.post(
        '/auth/login',
        obj
    );
}
